/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as SudoRouteImport } from './routes/sudo';
import { Route as SignupRouteImport } from './routes/signup';
import { Route as SigninRouteImport } from './routes/signin';
import { Route as ReleaseNotesRouteImport } from './routes/release-notes';
import { Route as OnboardingRouteImport } from './routes/onboarding';
import { Route as ContactRouteImport } from './routes/contact';
import { Route as AcceptInviteRouteImport } from './routes/accept-invite';
import { Route as IndexRouteImport } from './routes/index';
import { Route as SudoIndexRouteImport } from './routes/sudo.index';
import { Route as VoiceSlugRouteImport } from './routes/voice.$slug';
import { Route as SudoApiUsageRouteImport } from './routes/sudo.api-usage';
import { Route as MTokenRouteImport } from './routes/m.$token';
import { Route as ChatSlugRouteImport } from './routes/chat.$slug';
import { Route as BookSlugRouteImport } from './routes/book.$slug';
import { Route as AdminSlugRouteImport } from './routes/admin.$slug';
import { Route as SudoTemplatesIndexRouteImport } from './routes/sudo.templates.index';
import { Route as SudoInboxIndexRouteImport } from './routes/sudo.inbox.index';
import { Route as BookSlugIndexRouteImport } from './routes/book.$slug.index';
import { Route as AdminSlugIndexRouteImport } from './routes/admin.$slug.index';
import { Route as SudoInboxIdRouteImport } from './routes/sudo.inbox.$id';
import { Route as SudoBusinessesSlugRouteImport } from './routes/sudo.businesses.$slug';
import { Route as BookSlugServiceIdRouteImport } from './routes/book.$slug.$serviceId';
import { Route as AdminSlugWaitlistRouteImport } from './routes/admin.$slug.waitlist';
import { Route as AdminSlugTranslationsRouteImport } from './routes/admin.$slug.translations';
import { Route as AdminSlugSkillsRouteImport } from './routes/admin.$slug.skills';
import { Route as AdminSlugSettingsRouteImport } from './routes/admin.$slug.settings';
import { Route as AdminSlugServicesRouteImport } from './routes/admin.$slug.services';
import { Route as AdminSlugRosterRouteImport } from './routes/admin.$slug.roster';
import { Route as AdminSlugResourcesRouteImport } from './routes/admin.$slug.resources';
import { Route as AdminSlugReshuffleRouteImport } from './routes/admin.$slug.reshuffle';
import { Route as AdminSlugMyDayRouteImport } from './routes/admin.$slug.my-day';
import { Route as AdminSlugMyAvailabilityRouteImport } from './routes/admin.$slug.my-availability';
import { Route as AdminSlugMembersRouteImport } from './routes/admin.$slug.members';
import { Route as AdminSlugListsRouteImport } from './routes/admin.$slug.lists';
import { Route as AdminSlugCreateBookingRouteImport } from './routes/admin.$slug.create-booking';
import { Route as AdminSlugClosedDaysRouteImport } from './routes/admin.$slug.closed-days';
import { Route as AdminSlugClientsRouteImport } from './routes/admin.$slug.clients';
import { Route as AdminSlugBillingRouteImport } from './routes/admin.$slug.billing';
import { Route as AdminSlugApprovalsRouteImport } from './routes/admin.$slug.approvals';
import { Route as AdminSlugTemplatesIndexRouteImport } from './routes/admin.$slug.templates.index';
import { Route as SudoTemplatesKeyChannelRouteImport } from './routes/sudo.templates.$key.$channel';
import { Route as BookSlugBookedBookingIdRouteImport } from './routes/book.$slug.booked.$bookingId';
import { Route as AdminSlugTemplatesKeyChannelRouteImport } from './routes/admin.$slug.templates.$key.$channel';

const SudoRoute = SudoRouteImport.update({
  id: '/sudo',
  path: '/sudo',
  getParentRoute: () => rootRouteImport,
} as any);
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any);
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any);
const ReleaseNotesRoute = ReleaseNotesRouteImport.update({
  id: '/release-notes',
  path: '/release-notes',
  getParentRoute: () => rootRouteImport,
} as any);
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any);
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any);
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const SudoIndexRoute = SudoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SudoRoute,
} as any);
const VoiceSlugRoute = VoiceSlugRouteImport.update({
  id: '/voice/$slug',
  path: '/voice/$slug',
  getParentRoute: () => rootRouteImport,
} as any);
const SudoApiUsageRoute = SudoApiUsageRouteImport.update({
  id: '/api-usage',
  path: '/api-usage',
  getParentRoute: () => SudoRoute,
} as any);
const MTokenRoute = MTokenRouteImport.update({
  id: '/m/$token',
  path: '/m/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const ChatSlugRoute = ChatSlugRouteImport.update({
  id: '/chat/$slug',
  path: '/chat/$slug',
  getParentRoute: () => rootRouteImport,
} as any);
const BookSlugRoute = BookSlugRouteImport.update({
  id: '/book/$slug',
  path: '/book/$slug',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminSlugRoute = AdminSlugRouteImport.update({
  id: '/admin/$slug',
  path: '/admin/$slug',
  getParentRoute: () => rootRouteImport,
} as any);
const SudoTemplatesIndexRoute = SudoTemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => SudoRoute,
} as any);
const SudoInboxIndexRoute = SudoInboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => SudoRoute,
} as any);
const BookSlugIndexRoute = BookSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BookSlugRoute,
} as any);
const AdminSlugIndexRoute = AdminSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSlugRoute,
} as any);
const SudoInboxIdRoute = SudoInboxIdRouteImport.update({
  id: '/inbox/$id',
  path: '/inbox/$id',
  getParentRoute: () => SudoRoute,
} as any);
const SudoBusinessesSlugRoute = SudoBusinessesSlugRouteImport.update({
  id: '/businesses/$slug',
  path: '/businesses/$slug',
  getParentRoute: () => SudoRoute,
} as any);
const BookSlugServiceIdRoute = BookSlugServiceIdRouteImport.update({
  id: '/$serviceId',
  path: '/$serviceId',
  getParentRoute: () => BookSlugRoute,
} as any);
const AdminSlugWaitlistRoute = AdminSlugWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugTranslationsRoute = AdminSlugTranslationsRouteImport.update({
  id: '/translations',
  path: '/translations',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugSkillsRoute = AdminSlugSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugSettingsRoute = AdminSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugServicesRoute = AdminSlugServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugRosterRoute = AdminSlugRosterRouteImport.update({
  id: '/roster',
  path: '/roster',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugResourcesRoute = AdminSlugResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugReshuffleRoute = AdminSlugReshuffleRouteImport.update({
  id: '/reshuffle',
  path: '/reshuffle',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugMyDayRoute = AdminSlugMyDayRouteImport.update({
  id: '/my-day',
  path: '/my-day',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugMyAvailabilityRoute = AdminSlugMyAvailabilityRouteImport.update({
  id: '/my-availability',
  path: '/my-availability',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugMembersRoute = AdminSlugMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugListsRoute = AdminSlugListsRouteImport.update({
  id: '/lists',
  path: '/lists',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugCreateBookingRoute = AdminSlugCreateBookingRouteImport.update({
  id: '/create-booking',
  path: '/create-booking',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugClosedDaysRoute = AdminSlugClosedDaysRouteImport.update({
  id: '/closed-days',
  path: '/closed-days',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugClientsRoute = AdminSlugClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugBillingRoute = AdminSlugBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugApprovalsRoute = AdminSlugApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugTemplatesIndexRoute = AdminSlugTemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => AdminSlugRoute,
} as any);
const SudoTemplatesKeyChannelRoute = SudoTemplatesKeyChannelRouteImport.update({
  id: '/templates/$key/$channel',
  path: '/templates/$key/$channel',
  getParentRoute: () => SudoRoute,
} as any);
const BookSlugBookedBookingIdRoute = BookSlugBookedBookingIdRouteImport.update({
  id: '/booked/$bookingId',
  path: '/booked/$bookingId',
  getParentRoute: () => BookSlugRoute,
} as any);
const AdminSlugTemplatesKeyChannelRoute =
  AdminSlugTemplatesKeyChannelRouteImport.update({
    id: '/templates/$key/$channel',
    path: '/templates/$key/$channel',
    getParentRoute: () => AdminSlugRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/accept-invite': typeof AcceptInviteRoute;
  '/contact': typeof ContactRoute;
  '/onboarding': typeof OnboardingRoute;
  '/release-notes': typeof ReleaseNotesRoute;
  '/signin': typeof SigninRoute;
  '/signup': typeof SignupRoute;
  '/sudo': typeof SudoRouteWithChildren;
  '/admin/$slug': typeof AdminSlugRouteWithChildren;
  '/book/$slug': typeof BookSlugRouteWithChildren;
  '/chat/$slug': typeof ChatSlugRoute;
  '/m/$token': typeof MTokenRoute;
  '/sudo/api-usage': typeof SudoApiUsageRoute;
  '/voice/$slug': typeof VoiceSlugRoute;
  '/sudo/': typeof SudoIndexRoute;
  '/admin/$slug/approvals': typeof AdminSlugApprovalsRoute;
  '/admin/$slug/billing': typeof AdminSlugBillingRoute;
  '/admin/$slug/clients': typeof AdminSlugClientsRoute;
  '/admin/$slug/closed-days': typeof AdminSlugClosedDaysRoute;
  '/admin/$slug/create-booking': typeof AdminSlugCreateBookingRoute;
  '/admin/$slug/lists': typeof AdminSlugListsRoute;
  '/admin/$slug/members': typeof AdminSlugMembersRoute;
  '/admin/$slug/my-availability': typeof AdminSlugMyAvailabilityRoute;
  '/admin/$slug/my-day': typeof AdminSlugMyDayRoute;
  '/admin/$slug/reshuffle': typeof AdminSlugReshuffleRoute;
  '/admin/$slug/resources': typeof AdminSlugResourcesRoute;
  '/admin/$slug/roster': typeof AdminSlugRosterRoute;
  '/admin/$slug/services': typeof AdminSlugServicesRoute;
  '/admin/$slug/settings': typeof AdminSlugSettingsRoute;
  '/admin/$slug/skills': typeof AdminSlugSkillsRoute;
  '/admin/$slug/translations': typeof AdminSlugTranslationsRoute;
  '/admin/$slug/waitlist': typeof AdminSlugWaitlistRoute;
  '/book/$slug/$serviceId': typeof BookSlugServiceIdRoute;
  '/sudo/businesses/$slug': typeof SudoBusinessesSlugRoute;
  '/sudo/inbox/$id': typeof SudoInboxIdRoute;
  '/admin/$slug/': typeof AdminSlugIndexRoute;
  '/book/$slug/': typeof BookSlugIndexRoute;
  '/sudo/inbox/': typeof SudoInboxIndexRoute;
  '/sudo/templates/': typeof SudoTemplatesIndexRoute;
  '/book/$slug/booked/$bookingId': typeof BookSlugBookedBookingIdRoute;
  '/sudo/templates/$key/$channel': typeof SudoTemplatesKeyChannelRoute;
  '/admin/$slug/templates/': typeof AdminSlugTemplatesIndexRoute;
  '/admin/$slug/templates/$key/$channel': typeof AdminSlugTemplatesKeyChannelRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/accept-invite': typeof AcceptInviteRoute;
  '/contact': typeof ContactRoute;
  '/onboarding': typeof OnboardingRoute;
  '/release-notes': typeof ReleaseNotesRoute;
  '/signin': typeof SigninRoute;
  '/signup': typeof SignupRoute;
  '/chat/$slug': typeof ChatSlugRoute;
  '/m/$token': typeof MTokenRoute;
  '/sudo/api-usage': typeof SudoApiUsageRoute;
  '/voice/$slug': typeof VoiceSlugRoute;
  '/sudo': typeof SudoIndexRoute;
  '/admin/$slug/approvals': typeof AdminSlugApprovalsRoute;
  '/admin/$slug/billing': typeof AdminSlugBillingRoute;
  '/admin/$slug/clients': typeof AdminSlugClientsRoute;
  '/admin/$slug/closed-days': typeof AdminSlugClosedDaysRoute;
  '/admin/$slug/create-booking': typeof AdminSlugCreateBookingRoute;
  '/admin/$slug/lists': typeof AdminSlugListsRoute;
  '/admin/$slug/members': typeof AdminSlugMembersRoute;
  '/admin/$slug/my-availability': typeof AdminSlugMyAvailabilityRoute;
  '/admin/$slug/my-day': typeof AdminSlugMyDayRoute;
  '/admin/$slug/reshuffle': typeof AdminSlugReshuffleRoute;
  '/admin/$slug/resources': typeof AdminSlugResourcesRoute;
  '/admin/$slug/roster': typeof AdminSlugRosterRoute;
  '/admin/$slug/services': typeof AdminSlugServicesRoute;
  '/admin/$slug/settings': typeof AdminSlugSettingsRoute;
  '/admin/$slug/skills': typeof AdminSlugSkillsRoute;
  '/admin/$slug/translations': typeof AdminSlugTranslationsRoute;
  '/admin/$slug/waitlist': typeof AdminSlugWaitlistRoute;
  '/book/$slug/$serviceId': typeof BookSlugServiceIdRoute;
  '/sudo/businesses/$slug': typeof SudoBusinessesSlugRoute;
  '/sudo/inbox/$id': typeof SudoInboxIdRoute;
  '/admin/$slug': typeof AdminSlugIndexRoute;
  '/book/$slug': typeof BookSlugIndexRoute;
  '/sudo/inbox': typeof SudoInboxIndexRoute;
  '/sudo/templates': typeof SudoTemplatesIndexRoute;
  '/book/$slug/booked/$bookingId': typeof BookSlugBookedBookingIdRoute;
  '/sudo/templates/$key/$channel': typeof SudoTemplatesKeyChannelRoute;
  '/admin/$slug/templates': typeof AdminSlugTemplatesIndexRoute;
  '/admin/$slug/templates/$key/$channel': typeof AdminSlugTemplatesKeyChannelRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/accept-invite': typeof AcceptInviteRoute;
  '/contact': typeof ContactRoute;
  '/onboarding': typeof OnboardingRoute;
  '/release-notes': typeof ReleaseNotesRoute;
  '/signin': typeof SigninRoute;
  '/signup': typeof SignupRoute;
  '/sudo': typeof SudoRouteWithChildren;
  '/admin/$slug': typeof AdminSlugRouteWithChildren;
  '/book/$slug': typeof BookSlugRouteWithChildren;
  '/chat/$slug': typeof ChatSlugRoute;
  '/m/$token': typeof MTokenRoute;
  '/sudo/api-usage': typeof SudoApiUsageRoute;
  '/voice/$slug': typeof VoiceSlugRoute;
  '/sudo/': typeof SudoIndexRoute;
  '/admin/$slug/approvals': typeof AdminSlugApprovalsRoute;
  '/admin/$slug/billing': typeof AdminSlugBillingRoute;
  '/admin/$slug/clients': typeof AdminSlugClientsRoute;
  '/admin/$slug/closed-days': typeof AdminSlugClosedDaysRoute;
  '/admin/$slug/create-booking': typeof AdminSlugCreateBookingRoute;
  '/admin/$slug/lists': typeof AdminSlugListsRoute;
  '/admin/$slug/members': typeof AdminSlugMembersRoute;
  '/admin/$slug/my-availability': typeof AdminSlugMyAvailabilityRoute;
  '/admin/$slug/my-day': typeof AdminSlugMyDayRoute;
  '/admin/$slug/reshuffle': typeof AdminSlugReshuffleRoute;
  '/admin/$slug/resources': typeof AdminSlugResourcesRoute;
  '/admin/$slug/roster': typeof AdminSlugRosterRoute;
  '/admin/$slug/services': typeof AdminSlugServicesRoute;
  '/admin/$slug/settings': typeof AdminSlugSettingsRoute;
  '/admin/$slug/skills': typeof AdminSlugSkillsRoute;
  '/admin/$slug/translations': typeof AdminSlugTranslationsRoute;
  '/admin/$slug/waitlist': typeof AdminSlugWaitlistRoute;
  '/book/$slug/$serviceId': typeof BookSlugServiceIdRoute;
  '/sudo/businesses/$slug': typeof SudoBusinessesSlugRoute;
  '/sudo/inbox/$id': typeof SudoInboxIdRoute;
  '/admin/$slug/': typeof AdminSlugIndexRoute;
  '/book/$slug/': typeof BookSlugIndexRoute;
  '/sudo/inbox/': typeof SudoInboxIndexRoute;
  '/sudo/templates/': typeof SudoTemplatesIndexRoute;
  '/book/$slug/booked/$bookingId': typeof BookSlugBookedBookingIdRoute;
  '/sudo/templates/$key/$channel': typeof SudoTemplatesKeyChannelRoute;
  '/admin/$slug/templates/': typeof AdminSlugTemplatesIndexRoute;
  '/admin/$slug/templates/$key/$channel': typeof AdminSlugTemplatesKeyChannelRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/contact'
    | '/onboarding'
    | '/release-notes'
    | '/signin'
    | '/signup'
    | '/sudo'
    | '/admin/$slug'
    | '/book/$slug'
    | '/chat/$slug'
    | '/m/$token'
    | '/sudo/api-usage'
    | '/voice/$slug'
    | '/sudo/'
    | '/admin/$slug/approvals'
    | '/admin/$slug/billing'
    | '/admin/$slug/clients'
    | '/admin/$slug/closed-days'
    | '/admin/$slug/create-booking'
    | '/admin/$slug/lists'
    | '/admin/$slug/members'
    | '/admin/$slug/my-availability'
    | '/admin/$slug/my-day'
    | '/admin/$slug/reshuffle'
    | '/admin/$slug/resources'
    | '/admin/$slug/roster'
    | '/admin/$slug/services'
    | '/admin/$slug/settings'
    | '/admin/$slug/skills'
    | '/admin/$slug/translations'
    | '/admin/$slug/waitlist'
    | '/book/$slug/$serviceId'
    | '/sudo/businesses/$slug'
    | '/sudo/inbox/$id'
    | '/admin/$slug/'
    | '/book/$slug/'
    | '/sudo/inbox/'
    | '/sudo/templates/'
    | '/book/$slug/booked/$bookingId'
    | '/sudo/templates/$key/$channel'
    | '/admin/$slug/templates/'
    | '/admin/$slug/templates/$key/$channel';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/accept-invite'
    | '/contact'
    | '/onboarding'
    | '/release-notes'
    | '/signin'
    | '/signup'
    | '/chat/$slug'
    | '/m/$token'
    | '/sudo/api-usage'
    | '/voice/$slug'
    | '/sudo'
    | '/admin/$slug/approvals'
    | '/admin/$slug/billing'
    | '/admin/$slug/clients'
    | '/admin/$slug/closed-days'
    | '/admin/$slug/create-booking'
    | '/admin/$slug/lists'
    | '/admin/$slug/members'
    | '/admin/$slug/my-availability'
    | '/admin/$slug/my-day'
    | '/admin/$slug/reshuffle'
    | '/admin/$slug/resources'
    | '/admin/$slug/roster'
    | '/admin/$slug/services'
    | '/admin/$slug/settings'
    | '/admin/$slug/skills'
    | '/admin/$slug/translations'
    | '/admin/$slug/waitlist'
    | '/book/$slug/$serviceId'
    | '/sudo/businesses/$slug'
    | '/sudo/inbox/$id'
    | '/admin/$slug'
    | '/book/$slug'
    | '/sudo/inbox'
    | '/sudo/templates'
    | '/book/$slug/booked/$bookingId'
    | '/sudo/templates/$key/$channel'
    | '/admin/$slug/templates'
    | '/admin/$slug/templates/$key/$channel';
  id:
    | '__root__'
    | '/'
    | '/accept-invite'
    | '/contact'
    | '/onboarding'
    | '/release-notes'
    | '/signin'
    | '/signup'
    | '/sudo'
    | '/admin/$slug'
    | '/book/$slug'
    | '/chat/$slug'
    | '/m/$token'
    | '/sudo/api-usage'
    | '/voice/$slug'
    | '/sudo/'
    | '/admin/$slug/approvals'
    | '/admin/$slug/billing'
    | '/admin/$slug/clients'
    | '/admin/$slug/closed-days'
    | '/admin/$slug/create-booking'
    | '/admin/$slug/lists'
    | '/admin/$slug/members'
    | '/admin/$slug/my-availability'
    | '/admin/$slug/my-day'
    | '/admin/$slug/reshuffle'
    | '/admin/$slug/resources'
    | '/admin/$slug/roster'
    | '/admin/$slug/services'
    | '/admin/$slug/settings'
    | '/admin/$slug/skills'
    | '/admin/$slug/translations'
    | '/admin/$slug/waitlist'
    | '/book/$slug/$serviceId'
    | '/sudo/businesses/$slug'
    | '/sudo/inbox/$id'
    | '/admin/$slug/'
    | '/book/$slug/'
    | '/sudo/inbox/'
    | '/sudo/templates/'
    | '/book/$slug/booked/$bookingId'
    | '/sudo/templates/$key/$channel'
    | '/admin/$slug/templates/'
    | '/admin/$slug/templates/$key/$channel';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AcceptInviteRoute: typeof AcceptInviteRoute;
  ContactRoute: typeof ContactRoute;
  OnboardingRoute: typeof OnboardingRoute;
  ReleaseNotesRoute: typeof ReleaseNotesRoute;
  SigninRoute: typeof SigninRoute;
  SignupRoute: typeof SignupRoute;
  SudoRoute: typeof SudoRouteWithChildren;
  AdminSlugRoute: typeof AdminSlugRouteWithChildren;
  BookSlugRoute: typeof BookSlugRouteWithChildren;
  ChatSlugRoute: typeof ChatSlugRoute;
  MTokenRoute: typeof MTokenRoute;
  VoiceSlugRoute: typeof VoiceSlugRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sudo': {
      id: '/sudo';
      path: '/sudo';
      fullPath: '/sudo';
      preLoaderRoute: typeof SudoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/signup': {
      id: '/signup';
      path: '/signup';
      fullPath: '/signup';
      preLoaderRoute: typeof SignupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/signin': {
      id: '/signin';
      path: '/signin';
      fullPath: '/signin';
      preLoaderRoute: typeof SigninRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/release-notes': {
      id: '/release-notes';
      path: '/release-notes';
      fullPath: '/release-notes';
      preLoaderRoute: typeof ReleaseNotesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/onboarding': {
      id: '/onboarding';
      path: '/onboarding';
      fullPath: '/onboarding';
      preLoaderRoute: typeof OnboardingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/contact': {
      id: '/contact';
      path: '/contact';
      fullPath: '/contact';
      preLoaderRoute: typeof ContactRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/accept-invite': {
      id: '/accept-invite';
      path: '/accept-invite';
      fullPath: '/accept-invite';
      preLoaderRoute: typeof AcceptInviteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sudo/': {
      id: '/sudo/';
      path: '/';
      fullPath: '/sudo/';
      preLoaderRoute: typeof SudoIndexRouteImport;
      parentRoute: typeof SudoRoute;
    };
    '/voice/$slug': {
      id: '/voice/$slug';
      path: '/voice/$slug';
      fullPath: '/voice/$slug';
      preLoaderRoute: typeof VoiceSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sudo/api-usage': {
      id: '/sudo/api-usage';
      path: '/api-usage';
      fullPath: '/sudo/api-usage';
      preLoaderRoute: typeof SudoApiUsageRouteImport;
      parentRoute: typeof SudoRoute;
    };
    '/m/$token': {
      id: '/m/$token';
      path: '/m/$token';
      fullPath: '/m/$token';
      preLoaderRoute: typeof MTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/chat/$slug': {
      id: '/chat/$slug';
      path: '/chat/$slug';
      fullPath: '/chat/$slug';
      preLoaderRoute: typeof ChatSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/book/$slug': {
      id: '/book/$slug';
      path: '/book/$slug';
      fullPath: '/book/$slug';
      preLoaderRoute: typeof BookSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin/$slug': {
      id: '/admin/$slug';
      path: '/admin/$slug';
      fullPath: '/admin/$slug';
      preLoaderRoute: typeof AdminSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sudo/templates/': {
      id: '/sudo/templates/';
      path: '/templates';
      fullPath: '/sudo/templates/';
      preLoaderRoute: typeof SudoTemplatesIndexRouteImport;
      parentRoute: typeof SudoRoute;
    };
    '/sudo/inbox/': {
      id: '/sudo/inbox/';
      path: '/inbox';
      fullPath: '/sudo/inbox/';
      preLoaderRoute: typeof SudoInboxIndexRouteImport;
      parentRoute: typeof SudoRoute;
    };
    '/book/$slug/': {
      id: '/book/$slug/';
      path: '/';
      fullPath: '/book/$slug/';
      preLoaderRoute: typeof BookSlugIndexRouteImport;
      parentRoute: typeof BookSlugRoute;
    };
    '/admin/$slug/': {
      id: '/admin/$slug/';
      path: '/';
      fullPath: '/admin/$slug/';
      preLoaderRoute: typeof AdminSlugIndexRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/sudo/inbox/$id': {
      id: '/sudo/inbox/$id';
      path: '/inbox/$id';
      fullPath: '/sudo/inbox/$id';
      preLoaderRoute: typeof SudoInboxIdRouteImport;
      parentRoute: typeof SudoRoute;
    };
    '/sudo/businesses/$slug': {
      id: '/sudo/businesses/$slug';
      path: '/businesses/$slug';
      fullPath: '/sudo/businesses/$slug';
      preLoaderRoute: typeof SudoBusinessesSlugRouteImport;
      parentRoute: typeof SudoRoute;
    };
    '/book/$slug/$serviceId': {
      id: '/book/$slug/$serviceId';
      path: '/$serviceId';
      fullPath: '/book/$slug/$serviceId';
      preLoaderRoute: typeof BookSlugServiceIdRouteImport;
      parentRoute: typeof BookSlugRoute;
    };
    '/admin/$slug/waitlist': {
      id: '/admin/$slug/waitlist';
      path: '/waitlist';
      fullPath: '/admin/$slug/waitlist';
      preLoaderRoute: typeof AdminSlugWaitlistRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/translations': {
      id: '/admin/$slug/translations';
      path: '/translations';
      fullPath: '/admin/$slug/translations';
      preLoaderRoute: typeof AdminSlugTranslationsRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/skills': {
      id: '/admin/$slug/skills';
      path: '/skills';
      fullPath: '/admin/$slug/skills';
      preLoaderRoute: typeof AdminSlugSkillsRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/settings': {
      id: '/admin/$slug/settings';
      path: '/settings';
      fullPath: '/admin/$slug/settings';
      preLoaderRoute: typeof AdminSlugSettingsRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/services': {
      id: '/admin/$slug/services';
      path: '/services';
      fullPath: '/admin/$slug/services';
      preLoaderRoute: typeof AdminSlugServicesRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/roster': {
      id: '/admin/$slug/roster';
      path: '/roster';
      fullPath: '/admin/$slug/roster';
      preLoaderRoute: typeof AdminSlugRosterRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/resources': {
      id: '/admin/$slug/resources';
      path: '/resources';
      fullPath: '/admin/$slug/resources';
      preLoaderRoute: typeof AdminSlugResourcesRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/reshuffle': {
      id: '/admin/$slug/reshuffle';
      path: '/reshuffle';
      fullPath: '/admin/$slug/reshuffle';
      preLoaderRoute: typeof AdminSlugReshuffleRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/my-day': {
      id: '/admin/$slug/my-day';
      path: '/my-day';
      fullPath: '/admin/$slug/my-day';
      preLoaderRoute: typeof AdminSlugMyDayRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/my-availability': {
      id: '/admin/$slug/my-availability';
      path: '/my-availability';
      fullPath: '/admin/$slug/my-availability';
      preLoaderRoute: typeof AdminSlugMyAvailabilityRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/members': {
      id: '/admin/$slug/members';
      path: '/members';
      fullPath: '/admin/$slug/members';
      preLoaderRoute: typeof AdminSlugMembersRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/lists': {
      id: '/admin/$slug/lists';
      path: '/lists';
      fullPath: '/admin/$slug/lists';
      preLoaderRoute: typeof AdminSlugListsRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/create-booking': {
      id: '/admin/$slug/create-booking';
      path: '/create-booking';
      fullPath: '/admin/$slug/create-booking';
      preLoaderRoute: typeof AdminSlugCreateBookingRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/closed-days': {
      id: '/admin/$slug/closed-days';
      path: '/closed-days';
      fullPath: '/admin/$slug/closed-days';
      preLoaderRoute: typeof AdminSlugClosedDaysRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/clients': {
      id: '/admin/$slug/clients';
      path: '/clients';
      fullPath: '/admin/$slug/clients';
      preLoaderRoute: typeof AdminSlugClientsRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/billing': {
      id: '/admin/$slug/billing';
      path: '/billing';
      fullPath: '/admin/$slug/billing';
      preLoaderRoute: typeof AdminSlugBillingRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/approvals': {
      id: '/admin/$slug/approvals';
      path: '/approvals';
      fullPath: '/admin/$slug/approvals';
      preLoaderRoute: typeof AdminSlugApprovalsRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/templates/': {
      id: '/admin/$slug/templates/';
      path: '/templates';
      fullPath: '/admin/$slug/templates/';
      preLoaderRoute: typeof AdminSlugTemplatesIndexRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/sudo/templates/$key/$channel': {
      id: '/sudo/templates/$key/$channel';
      path: '/templates/$key/$channel';
      fullPath: '/sudo/templates/$key/$channel';
      preLoaderRoute: typeof SudoTemplatesKeyChannelRouteImport;
      parentRoute: typeof SudoRoute;
    };
    '/book/$slug/booked/$bookingId': {
      id: '/book/$slug/booked/$bookingId';
      path: '/booked/$bookingId';
      fullPath: '/book/$slug/booked/$bookingId';
      preLoaderRoute: typeof BookSlugBookedBookingIdRouteImport;
      parentRoute: typeof BookSlugRoute;
    };
    '/admin/$slug/templates/$key/$channel': {
      id: '/admin/$slug/templates/$key/$channel';
      path: '/templates/$key/$channel';
      fullPath: '/admin/$slug/templates/$key/$channel';
      preLoaderRoute: typeof AdminSlugTemplatesKeyChannelRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
  }
}

interface SudoRouteChildren {
  SudoApiUsageRoute: typeof SudoApiUsageRoute;
  SudoIndexRoute: typeof SudoIndexRoute;
  SudoBusinessesSlugRoute: typeof SudoBusinessesSlugRoute;
  SudoInboxIdRoute: typeof SudoInboxIdRoute;
  SudoInboxIndexRoute: typeof SudoInboxIndexRoute;
  SudoTemplatesIndexRoute: typeof SudoTemplatesIndexRoute;
  SudoTemplatesKeyChannelRoute: typeof SudoTemplatesKeyChannelRoute;
}

const SudoRouteChildren: SudoRouteChildren = {
  SudoApiUsageRoute: SudoApiUsageRoute,
  SudoIndexRoute: SudoIndexRoute,
  SudoBusinessesSlugRoute: SudoBusinessesSlugRoute,
  SudoInboxIdRoute: SudoInboxIdRoute,
  SudoInboxIndexRoute: SudoInboxIndexRoute,
  SudoTemplatesIndexRoute: SudoTemplatesIndexRoute,
  SudoTemplatesKeyChannelRoute: SudoTemplatesKeyChannelRoute,
};

const SudoRouteWithChildren = SudoRoute._addFileChildren(SudoRouteChildren);

interface AdminSlugRouteChildren {
  AdminSlugApprovalsRoute: typeof AdminSlugApprovalsRoute;
  AdminSlugBillingRoute: typeof AdminSlugBillingRoute;
  AdminSlugClientsRoute: typeof AdminSlugClientsRoute;
  AdminSlugClosedDaysRoute: typeof AdminSlugClosedDaysRoute;
  AdminSlugCreateBookingRoute: typeof AdminSlugCreateBookingRoute;
  AdminSlugListsRoute: typeof AdminSlugListsRoute;
  AdminSlugMembersRoute: typeof AdminSlugMembersRoute;
  AdminSlugMyAvailabilityRoute: typeof AdminSlugMyAvailabilityRoute;
  AdminSlugMyDayRoute: typeof AdminSlugMyDayRoute;
  AdminSlugReshuffleRoute: typeof AdminSlugReshuffleRoute;
  AdminSlugResourcesRoute: typeof AdminSlugResourcesRoute;
  AdminSlugRosterRoute: typeof AdminSlugRosterRoute;
  AdminSlugServicesRoute: typeof AdminSlugServicesRoute;
  AdminSlugSettingsRoute: typeof AdminSlugSettingsRoute;
  AdminSlugSkillsRoute: typeof AdminSlugSkillsRoute;
  AdminSlugTranslationsRoute: typeof AdminSlugTranslationsRoute;
  AdminSlugWaitlistRoute: typeof AdminSlugWaitlistRoute;
  AdminSlugIndexRoute: typeof AdminSlugIndexRoute;
  AdminSlugTemplatesIndexRoute: typeof AdminSlugTemplatesIndexRoute;
  AdminSlugTemplatesKeyChannelRoute: typeof AdminSlugTemplatesKeyChannelRoute;
}

const AdminSlugRouteChildren: AdminSlugRouteChildren = {
  AdminSlugApprovalsRoute: AdminSlugApprovalsRoute,
  AdminSlugBillingRoute: AdminSlugBillingRoute,
  AdminSlugClientsRoute: AdminSlugClientsRoute,
  AdminSlugClosedDaysRoute: AdminSlugClosedDaysRoute,
  AdminSlugCreateBookingRoute: AdminSlugCreateBookingRoute,
  AdminSlugListsRoute: AdminSlugListsRoute,
  AdminSlugMembersRoute: AdminSlugMembersRoute,
  AdminSlugMyAvailabilityRoute: AdminSlugMyAvailabilityRoute,
  AdminSlugMyDayRoute: AdminSlugMyDayRoute,
  AdminSlugReshuffleRoute: AdminSlugReshuffleRoute,
  AdminSlugResourcesRoute: AdminSlugResourcesRoute,
  AdminSlugRosterRoute: AdminSlugRosterRoute,
  AdminSlugServicesRoute: AdminSlugServicesRoute,
  AdminSlugSettingsRoute: AdminSlugSettingsRoute,
  AdminSlugSkillsRoute: AdminSlugSkillsRoute,
  AdminSlugTranslationsRoute: AdminSlugTranslationsRoute,
  AdminSlugWaitlistRoute: AdminSlugWaitlistRoute,
  AdminSlugIndexRoute: AdminSlugIndexRoute,
  AdminSlugTemplatesIndexRoute: AdminSlugTemplatesIndexRoute,
  AdminSlugTemplatesKeyChannelRoute: AdminSlugTemplatesKeyChannelRoute,
};

const AdminSlugRouteWithChildren = AdminSlugRoute._addFileChildren(
  AdminSlugRouteChildren,
);

interface BookSlugRouteChildren {
  BookSlugServiceIdRoute: typeof BookSlugServiceIdRoute;
  BookSlugIndexRoute: typeof BookSlugIndexRoute;
  BookSlugBookedBookingIdRoute: typeof BookSlugBookedBookingIdRoute;
}

const BookSlugRouteChildren: BookSlugRouteChildren = {
  BookSlugServiceIdRoute: BookSlugServiceIdRoute,
  BookSlugIndexRoute: BookSlugIndexRoute,
  BookSlugBookedBookingIdRoute: BookSlugBookedBookingIdRoute,
};

const BookSlugRouteWithChildren = BookSlugRoute._addFileChildren(
  BookSlugRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcceptInviteRoute: AcceptInviteRoute,
  ContactRoute: ContactRoute,
  OnboardingRoute: OnboardingRoute,
  ReleaseNotesRoute: ReleaseNotesRoute,
  SigninRoute: SigninRoute,
  SignupRoute: SignupRoute,
  SudoRoute: SudoRouteWithChildren,
  AdminSlugRoute: AdminSlugRouteWithChildren,
  BookSlugRoute: BookSlugRouteWithChildren,
  ChatSlugRoute: ChatSlugRoute,
  MTokenRoute: MTokenRoute,
  VoiceSlugRoute: VoiceSlugRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
